// extracted by mini-css-extract-plugin
module.exports = {"root":"COtKfoV","types":"rsqZ_xd"};
    if(module.hot) {
      // 1545369445341
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  